export const IPO_CAMPAIGN_ID = "ipo_promotion";
export const GARTNER_CAMPAIGN_ID = "gartner_campaign";
